import React, { Component } from 'react';
import { connect } from 'react-redux';
import {spring} from 'react-motion';
import Transition from 'react-motion-ui-pack';
import {ModalApply} from '../../components';

import './styles.css';

class Modal extends Component {
  render(){
    return (
      <Transition
        component={false}
        enter={{
          opacity: 1,
          translateY: spring(0, {stiffness: 100, damping: 15})
        }}
        leave={{
          opacity: 0,
          translateY: 250
        }}
      >
        { this.props.modal.showPopup &&
          <div key="modal" className="modal__content">
            <ModalApply />
          </div>
        }
      </Transition>
    )
  }
}

const mapStateToProps = (state) => ({
  modal: state.apply,
})

export default connect(mapStateToProps)(Modal);



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js